// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.content {
  height: 100%;
  overflow: hidden;
}

table {
  width: 100%;
}

#stats-table {
  width: 400px;
}

tr {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

#add-run-button mat-icon {
  color: rgba(0, 0, 0, 0.6);
}

.mat-icon {
  cursor: pointer;
}

table > markdown {
  font-size: 8px;
}

app-perf-chart {
  display: inline-block;
  width: 100%;
}

#wrapper {
  box-sizing: border-box;
  height: 100%;
  min-height: 100%;
  padding: 16px;
}

#tab-group {
  height: 100%;
}

#tab-group mat-tab-body {
  flex-grow: 1;
}

.compact {
  height: 38px !important;
}

.compact td,
.compact th {
  font-size: 9pt;
}

#table-container {
  overflow-x: hidden;
  overflow-y: auto;
  width: 250px;
}

mat-grid-list {
  height: calc(100vh - 200px);
}

#grid-column-selector {
  margin-top: 20px;
}

#table-container {
  position: absolute;
  top: 50%;
  right: 0;
  overflow-y: auto;
  height: calc(50% - 120px) !important;
}

.spacer {
  flex: 1 1 auto;
}

.toolbar {
  padding-top: 10px !important;
}

.share-btn-container {
  text-align: right;
}

.parent-split {
  overflow: hidden !important;
}

.mat-mdc-select {
  font-size: 14px;
}

.hide-overflow {
  overflow: hidden !important;
}

.fix-align {
  margin-left: -4px;
  text-align: left;
}

.refresh-btn {
  margin-right: 3px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 28px;
  line-height: 20px;
}

.select-sort-header {
  margin-top: 12px;
}

app-perf-table {
  height: 100%;
  display: block;
}

.table-area {
  display: flex !important;
  flex-direction: column;
  overflow: hidden !important;
}

.table-scroll-container {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.table-scroll-container::-webkit-scrollbar {
  width: 8px;
}
.table-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}
.table-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.table-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}

::ng-deep .mat-mdc-select-panel {
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar {
  width: 8px;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-track {
  background: transparent;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}

.row-spinner {
  display: inline-block;
  margin-top: 5px;
  margin-left: 2px;
  width: 20px;
  height: 20px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  opacity: 0.5;
  font-size: 14px;
}
.empty-state.grid-empty-state {
  min-height: 200px;
}

.state-icon {
  cursor: pointer;
  display: inline-block;
}
.state-icon .state-hover {
  display: none;
}
.state-icon:hover .state-default {
  display: none;
}
.state-icon:hover .state-hover {
  display: inline-block;
}
.state-icon.running:hover .state-hover {
  color: #d32f2f;
}

.active-filter {
  color: #1976d2;
  background: rgba(25, 118, 210, 0.08);
  border-radius: 50%;
}

.column-search {
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid rgba(128, 128, 128, 0.3);
  outline: none;
  font-size: 14px;
  background: transparent;
  color: inherit;
  box-sizing: border-box;
}

::ng-deep .hidden-option {
  display: none !important;
}

.description-cell {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pin-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  opacity: 0.2;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 4px;
}
.pin-icon.pinned {
  opacity: 1;
  color: #1976d2;
}
.pin-icon:hover {
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/experiments/experiments.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,sBAAA;EACA,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,OAAA;EACA,aAAA;EACA,qBAAA;EACA,qDAAA;AACF;AACE;EACE,UAAA;AACJ;AAEE;EACE,uBAAA;AAAJ;AAGE;EACE,oCAAA;EACA,kBAAA;AADJ;AAGI;EACE,oCAAA;AADN;;AAMA;EACE,qBAAA;EACA,qDAAA;AAHF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,uBAAA;AAJJ;AAOE;EACE,oCAAA;EACA,kBAAA;AALJ;AAOI;EACE,oCAAA;AALN;;AAUA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAPF;AASE;EACE,iBAAA;AAPJ;;AAWA;EACE,eAAA;EACA,qBAAA;AARF;AAUE;EACE,aAAA;AARJ;AAYI;EACE,aAAA;AAVN;AAYI;EACE,qBAAA;AAVN;AAcE;EACE,cAAA;AAZJ;;AAgBA;EACE,cAAA;EACA,oCAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,wBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAbF;AAeE;EACE,UAAA;EACA,cAAA;AAbJ;AAgBE;EACE,YAAA;AAdJ","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.content {\n  height: 100%;\n  overflow: hidden;\n}\n\ntable {\n  width: 100%;\n}\n\n#stats-table {\n  width: 400px;\n}\n\ntr {\n  cursor: pointer;\n  user-select: none;\n}\n\n#add-run-button mat-icon {\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.mat-icon {\n  cursor: pointer;\n}\n\ntable > markdown {\n  font-size: 8px;\n}\n\napp-perf-chart {\n  display: inline-block;\n  width: 100%;\n}\n\n#wrapper {\n  box-sizing: border-box;\n  height: 100%;\n  min-height: 100%;\n  padding: 16px;\n}\n\n#tab-group {\n  height: 100%;\n}\n\n#tab-group mat-tab-body {\n  flex-grow: 1;\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.compact td,\n.compact th {\n  font-size: 9pt;\n}\n\n#table-container {\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 250px;\n}\n\nmat-grid-list {\n  height: calc(100vh - 200px);\n}\n\n#grid-column-selector {\n  margin-top: 20px;\n}\n\n#table-container {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  overflow-y: auto;\n  height: calc(50% - 120px) !important;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n.toolbar {\n  padding-top: 10px !important;\n}\n\n.share-btn-container {\n  text-align: right;\n}\n\n.parent-split {\n  overflow: hidden !important;\n}\n\n.mat-mdc-select {\n  font-size: 14px;\n}\n\n.hide-overflow {\n  overflow: hidden !important;\n}\n\n.fix-align {\n  margin-left: -4px;\n  text-align: left;\n}\n\n.refresh-btn {\n  margin-right: 3px;\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 28px;\n  line-height: 20px;\n}\n\n.select-sort-header {\n  margin-top: 12px;\n}\n\napp-perf-table {\n  height: 100%;\n  display: block;\n}\n\n.table-area {\n  display: flex !important;\n  flex-direction: column;\n  overflow: hidden !important;\n}\n\n.table-scroll-container {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n}\n\n::ng-deep .mat-mdc-select-panel {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n}\n\n.row-spinner {\n  display: inline-block;\n  margin-top: 5px;\n  margin-left: 2px;\n  width: 20px;\n  height: 20px;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 100%;\n  opacity: 0.5;\n  font-size: 14px;\n\n  &.grid-empty-state {\n    min-height: 200px;\n  }\n}\n\n.state-icon {\n  cursor: pointer;\n  display: inline-block;\n\n  .state-hover {\n    display: none;\n  }\n\n  &:hover {\n    .state-default {\n      display: none;\n    }\n    .state-hover {\n      display: inline-block;\n    }\n  }\n\n  &.running:hover .state-hover {\n    color: #d32f2f;\n  }\n}\n\n.active-filter {\n  color: #1976d2;\n  background: rgba(25, 118, 210, 0.08);\n  border-radius: 50%;\n}\n\n.column-search {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.3);\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n  color: inherit;\n  box-sizing: border-box;\n}\n\n::ng-deep .hidden-option {\n  display: none !important;\n}\n\n.description-cell {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pin-icon {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  opacity: 0.2;\n  cursor: pointer;\n  vertical-align: middle;\n  margin-right: 4px;\n\n  &.pinned {\n    opacity: 1;\n    color: #1976d2;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
